import { useEffect, useRef } from "react";

function usePrevious(value: unknown) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value as undefined;
    }, [value]);
    return ref.current;
}

export default usePrevious;
